// Native File values cross the port; Elm reads and converts their text.
// The document adapter sanitizes the resulting HTML before using it.
let parser,requestId=0;
const pending=new Map();

function convert(payload){
  if(!parser){
    parser=window.Elm.MarkdownImport.init();
    parser.ports.parsedMarkdown.subscribe(result=>{
      const request=pending.get(result.id);
      if(!request)return;
      pending.delete(result.id);
      if(result.error)request.reject(new Error(result.error));
      else request.resolve(result.html);
    });
  }
  return new Promise((resolve,reject)=>{
    const id=++requestId;
    pending.set(id,{resolve,reject});
    // Initial subscriptions settle after the parent Elm effect returns.
    queueMicrotask(()=>{
      try{parser.ports.parseMarkdown.send({id,...payload});}
      catch(error){pending.delete(id);reject(error);}
    });
  });
}

export const textHtml=(source,markdown=true)=>convert({source,markdown});
export const fileHtml=(file,markdown=true)=>convert({file,markdown});
